<template lang="pug">
  el-col.datacell
    el-input.input-with-select(placeholder='请输入体量'
            type="number"
            ref="input__"
            :size="GLOBAL.SIZE_OF_INPUTBOX"
            @keypress.enter.native="handleChange"
            v-model="cellData.size")
      template(slot="prepend") {{cellData.year+(XunitName||'')}}
      //- el-select(v-model="cellData.year"
      //-           slot="prepend"
      //-           @change="reflash"
      //-           placeholder="年份")
        //- el-option(v-for="year in years"
        //-         :size="GLOBAL.SIZE_OF_INPUTBOX"
        //-         :label="(year + '年')"
        //-         :value="year"
        //-         :key="year" )
      el-checkbox(slot="append"
                  label="预测"
                  :size="GLOBAL.SIZE_OF_INPUTBOX"
                  v-model="cellData.predictive"
                  :true-label="1"
                  :false-label="0"
                  @change="handelPredictive")
      //- el-button(slot="append"
      //-           :size="GLOBAL.SIZE_OF_INPUTBOX"
      //-           style="margin-left:5px;"
      //-           @click="removeMe"
      //-           icon="el-icon-delete")
</template>
<script>
export default {
  name: 'DataCell',
  props: ['cellData', 'index', 'XunitName'],
  data () {
    const years = []
    for (let i = 1990; i < 2030; i++) years.push(i)
    return {
      years,
      alertYearVal: false
    }
  },
  mounted () {
    this.$refs.input__.focus()
  },
  methods: {
    handleChange (e, f) {
      if (e.key === 'Enter') {
        this.$emit('addNew')
      }
    },
    // removeMe () {
    //   this.$emit('remove', this.index)
    // },
    checkValue () {
      this.alertYearVal = this.cellData.year < 1900 || this.data > 2100
    },
    reflash () { this.$forceUpdate() },
    handelPredictive () {
      this.$emit('predictive', this.cellData.predictive, this.index)
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="scss">
.datacell {
  margin-bottom: 5px;
  .el-input__inner {
    padding-left: 8px;
    padding-right: 5px;
  }
  .el-input .el-select {
    width: 85px;
  }
  .el-input-group__append {
    padding: 0 10px;
  }
  .el-input-group__append {
    button {
      padding: 12px 10px;
      margin: -10px;
    }
  }
}
</style>
